import { DISPATCH_API, WEB_ROUTES } from '~/utils/webConfig';
import { BIOMETRY_STATUS } from '~/components/profile/utils';

export default async function({ app, $api, softRedirect }) {
  const isAllowEditBiometryProfile =
    app.$client.profile &&
    app.$client.profile.clientBiometry &&
    app.$client.profile.clientBiometry.allowEditBiometryProfile;
  if (isAllowEditBiometryProfile) {
    return;
  }

  const {
    data: { status },
  } = await $api.dispatch(DISPATCH_API.GET_BIOMETRY_STATUS);
  if (status && status === BIOMETRY_STATUS.ACTIVE) {
    return;
  }

  softRedirect(app.localePath(WEB_ROUTES.PROFILE));
}
